export default __webpack_public_path__ + "banner-card-icon22cf3c6.png";